import React from "react";
import { useSelector } from "react-redux";

import './cast.scss'

import ContentWrapper from "../../../contentWrapper/ContentWrapper";
import Img from "../../../lazyloading/Image";
import avatar from "../../../Moviex-images/avatar.png";

const Cast = ({ cast:data, creditLoading:loading }) => {
    const { url } = useSelector((state) => state.home);
  

    const skeleton = () => {
        return (
            <div className="skItem">
                <div className="circle skeleton"></div>
                <div className="row skeleton"></div>
                <div className="row2 skeleton"></div>
            </div>
        );
    };
    return (
        <div className="castSection">
            <ContentWrapper>
                <div className="sectionHeading">Top Cast</div>
                {!loading ? (
                    <div className="listItems">
                    {data?.map((item)=>{
                        
                        
                        
                        const posterUrl = item.profile_path? url.backdrop + item.profile_path :avatar;
                        return(
                            <div key={item.id} className="listItem">
                                <div className="profileImg">
                                    <Img src={posterUrl}/>
                                </div>
                                <div className="name">
                                    {item.name}
                                </div>
                                <div className="character">
                                    {item.character}
                                </div>

                            </div>
                        )
                    })}
                    </div>
                ) : (
                    <div className="castSkeleton">
                        {skeleton()}
                        {skeleton()}
                        {skeleton()}
                        {skeleton()}
                        {skeleton()}
                        {skeleton()}
                    </div>
                )}
            </ContentWrapper>
        </div>
    );
};

export default Cast;